import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const File = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M7.96265 3.79602C9.16601 2.59267 10.7981 1.91663 12.4999 1.91663H29.1666H29.1667C29.7962 1.91663 30.3653 2.17512 30.7737 2.59175L43.2417 15.0598C43.6583 15.4682 43.9167 16.0372 43.9167 16.6666L43.9166 16.6938V41.6666C43.9166 43.3684 43.2405 45.0005 42.0372 46.2039C40.8338 47.4072 39.2017 48.0833 37.4999 48.0833H12.4999C10.7981 48.0833 9.16601 47.4072 7.96265 46.2039C6.75929 45.0005 6.08325 43.3684 6.08325 41.6666V8.33329C6.08325 6.63149 6.75929 4.99938 7.96265 3.79602ZM12.4999 6.41663H26.9167V16.6666C26.9167 17.9093 27.9241 18.9166 29.1667 18.9166H39.4166V41.6666C39.4166 42.175 39.2147 42.6625 38.8552 43.0219C38.4958 43.3814 38.0083 43.5833 37.4999 43.5833H12.4999C11.9916 43.5833 11.5041 43.3814 11.1446 43.0219C10.7852 42.6625 10.5833 42.175 10.5833 41.6666V8.33329C10.5833 7.82496 10.7852 7.33745 11.1446 6.978C11.5041 6.61856 11.9916 6.41663 12.4999 6.41663ZM31.4167 9.59877L36.2346 14.4166H31.4167V9.59877ZM16.6667 24.8334C15.4241 24.8334 14.4167 25.8407 14.4167 27.0834C14.4167 28.326 15.4241 29.3334 16.6667 29.3334H33.3334C34.5761 29.3334 35.5834 28.326 35.5834 27.0834C35.5834 25.8407 34.5761 24.8334 33.3334 24.8334H16.6667ZM14.4167 35.4166C14.4167 34.174 15.4241 33.1666 16.6667 33.1666H33.3334C34.5761 33.1666 35.5834 34.174 35.5834 35.4166C35.5834 36.6593 34.5761 37.6666 33.3334 37.6666H16.6667C15.4241 37.6666 14.4167 36.6593 14.4167 35.4166ZM16.6667 16.5C15.4241 16.5 14.4167 17.5074 14.4167 18.75C14.4167 19.9926 15.4241 21 16.6667 21H18.7501H20.8334C22.0761 21 23.0834 19.9926 23.0834 18.75C23.0834 17.5074 22.0761 16.5 20.8334 16.5H18.7501H16.6667Z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  )
}
